"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.sendMessage = sendMessage;
exports.sendMessageToGroup = sendMessageToGroup;
exports.onMessageForConnectChannel = onMessageForConnectChannel;
exports.register = register;
exports.unregister = unregister;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _MessagingService = _interopRequireDefault(require("../MessagingService"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _DataStore = _interopRequireWildcard(require("../../Stores/DataStore2"));

var _AppUtils = require("../../../utils/AppUtils");

// eslint-disable-line
var CHANNEL = 'QDKesiConnect';
/*
async function getAppChannelName () {
  return CHANNEL

}
*/

var REGISTRATIONS = {};

function sendMessage(_x, _x2) {
  return _sendMessage.apply(this, arguments);
}

function _sendMessage() {
  _sendMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(eventName, message) {
    var channelName,
        channel,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            channelName = _args.length > 2 && _args[2] !== undefined ? _args[2] : CHANNEL;
            console.log('ConnectChannel: Sending single message');
            _context.next = 4;
            return _MessagingService["default"].getChannel(channelName);

          case 4:
            channel = _context.sent;

            _MessagingService["default"].sendMessage(channel, eventName, message);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sendMessage.apply(this, arguments);
}

function sendMessageToGroup(_x3) {
  return _sendMessageToGroup.apply(this, arguments);
}

function _sendMessageToGroup() {
  _sendMessageToGroup = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(eventName) {
    var message,
        partners,
        i,
        channel,
        _args2 = arguments;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            message = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            console.log('MESSAGE TO GROUP MESSAGE: ', message);
            _context2.next = 4;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS);

          case 4:
            partners = _context2.sent;

            if (!partners) {
              _context2.next = 15;
              break;
            }

            i = 0;

          case 7:
            if (!(i < partners.length)) {
              _context2.next = 15;
              break;
            }

            _context2.next = 10;
            return _MessagingService["default"].getChannel('private:' + partners[i]);

          case 10:
            channel = _context2.sent;

            _MessagingService["default"].sendMessage(channel, eventName, message);

          case 12:
            i++;
            _context2.next = 7;
            break;

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _sendMessageToGroup.apply(this, arguments);
}

function onMessageForConnectChannel(message) {
  var command = message.name;
  console.log('On message for connect channel', message);

  if (command === 'requestConnection' && message.data) {
    (0, _AppUtils.callListenersForAblyMessageWithcommand)(command, message);
  }
}

function register(_x4, _x5) {
  return _register.apply(this, arguments);
}

function _register() {
  _register = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(onMessage, caller) {
    var appChannel,
        appChannelCallbacks,
        _args3 = arguments;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            appChannel = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : CHANNEL;

            if (!_config["default"].registerForPrivateAblyChannelWithDeviceUuid) {
              _context3.next = 7;
              break;
            }

            _context3.next = 4;
            return _MessagingService["default"].getChannel(appChannel);

          case 4:
            _context3.next = 6;
            return _MessagingService["default"].registerChannel(appChannel, onMessage);

          case 6:
            if (typeof REGISTRATIONS[appChannel] === 'undefined' || REGISTRATIONS[appChannel].indexOf(caller) === -1) {
              appChannelCallbacks = REGISTRATIONS[appChannel] || [];
              appChannelCallbacks.push(caller);
              REGISTRATIONS[appChannel] = appChannelCallbacks;
              console.log('ably register', REGISTRATIONS);
            }

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _register.apply(this, arguments);
}

function unregister(_x6, _x7) {
  return _unregister.apply(this, arguments);
}

function _unregister() {
  _unregister = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(onMessage, caller) {
    var appChannel,
        appChannelCallbacks,
        index,
        _args4 = arguments;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            appChannel = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : CHANNEL;

            if (!_config["default"].registerForPrivateAblyChannelWithDeviceUuid) {
              _context4.next = 6;
              break;
            }

            appChannelCallbacks = REGISTRATIONS[appChannel];
            _context4.next = 5;
            return _MessagingService["default"].unregisterChannel(appChannel, onMessage);

          case 5:
            if (appChannelCallbacks) {
              index = appChannelCallbacks.indexOf(caller);
              appChannelCallbacks.splice(index, 1);
              REGISTRATIONS[appChannel] = appChannelCallbacks;
            }

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _unregister.apply(this, arguments);
}